import React from 'react';
import { Box, Divider, Paper, Typography } from '@mui/material';
import { LoadableTypography, Loader, ScrollableView } from '@uplift/ui-v2';


export const ChartsReviewLayout: React.VFC<{
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  left: React.ReactNode;
  right: React.ReactNode;
}> = ({ title, subtitle, left, right }) => {
  return (
    <Paper variant="outlined" square sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      <Box sx={{ px: 2, py: 1.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>
          <React.Suspense fallback={<LoadableTypography width="250px" />}>
            <Typography variant="body1" fontWeight={600}>{title}</Typography>
          </React.Suspense>
        </Box>

        {subtitle && (
          <Box>
            {subtitle}
          </Box>
        )}
      </Box>
      <Divider />
      <Box sx={{ display: 'flex', flex: 1 }}>
        <ScrollableView showScrollShadow>
          <Box sx={{ p: 2, flex: 1, display: 'flex', }}>
            <React.Suspense fallback={<Loader color="primary" />}>
              {left}
            </React.Suspense>
          </Box>
        </ScrollableView>
        <Box>
          <Divider orientation="vertical" sx={{ height: '100%' }} />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
          <React.Suspense fallback={<Loader color="primary" />}>
            {right}
          </React.Suspense>
        </Box>
      </Box>
    </Paper>
  );
};
